import { render, staticRenderFns } from "./BankPackagesList.vue?vue&type=template&id=6c4ba136&scoped=true&"
import script from "./BankPackagesList.vue?vue&type=script&lang=js&"
export * from "./BankPackagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4ba136",
  null
  
)

export default component.exports